import './index.scss'
import React from 'react'
import Base from '../base'
import _timeAgo from 'timeago.js'

// 九宫格布局
export default class Media extends Base {
  render() {
    const timeAgo = _timeAgo()
    return (
      <div className="section-collection-articles articles-layout-media">
        <div className="container">
          {this.state.articles.map((article, index) =>
            <div className="collection-article-item" key={"article-" + article.guid + index}>
              <div className="row">
                <div className="col-xs-4">
                  <a href={article.path || ""} className="collection-article-cover">
                    {
                      (article.cover || {}).url &&
                      <img alt={article.title}
                           src={article.cover.url + "?imageMogr2/format/jpeg/thumbnail/320x/gravity/center/crop/320x200"} />
                    }
                    {
                      (article.cover || {}).ext.toLowerCase() === '.gif' &&
                      <span className="fi fi-gif">GIF</span>
                    }
                  </a>
                </div>
                <div className="col-xs-8">
                  <h3 className="article-title"><a href={article.path || ""}>{article.title}</a></h3>
                  <div className="article-description text-muted">{article.subtitle || ""}</div>
                  <div className="article-info">
                    <span>{timeAgo.format(article.published_at, 'zh_CN')}</span>
                    {
                      article.collections.length > 0 &&
                      <span className="article-tags">
                        <i className="fi fi-tag"> </i>
                          {article.collections.map((collection, index) =>
                            <span key={"article-collection-"+index}>{collection.name}</span>
                          )}
                      </span>
                    }
                  </div>
                </div>
              </div>
            </div>
          )}

          {super.render()}
        </div>
      </div>
    )
  }
}


// WEBPACK FOOTER //
// ./app/javascript/app/site/structures/section/collection/articles/media/index.js